import { useEffect, useState } from 'react';

import useStore from '../../store';

const useGuestDocuments = (id: string, booking_id: string): boolean => {
  const [isLoading, setIsLoading] = useState(id === null ? false : true);

  const getGuestDocuments = useStore(state => state.getGuestDocuments);

  useEffect(() => {
    if (id !== null) {
      const getDocuments = async () => {
        try {
          await getGuestDocuments(id, booking_id);
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      };

      getDocuments();
    }
  }, [id]);

  return isLoading;
};

export default useGuestDocuments;
